import { CustomRoleTranslator } from 'src/translators'
import { CustomRoleFormEntity } from 'src/types'
import {
  useCreateCompanyRoleMutation,
  useUpdateCompanyRoleMutation,
  useDeleteCompanyRoleMutation,
} from 'src/types/generated'

type CreateCustomRoleInput = {
  formEntity: CustomRoleFormEntity
}
type UpdateCustomRoleInput = {
  roleId: number
  formEntity: CustomRoleFormEntity
}
type DeleteCustomRoleInput = {
  roleId: number
}

export const useCustomRole = () => {
  const [createCompanyRoleMutation] = useCreateCompanyRoleMutation()
  const [updateCompanyRoleMutation] = useUpdateCompanyRoleMutation()
  const [deleteCompanyRoleMutation] = useDeleteCompanyRoleMutation()

  const createCustomRole = async ({ formEntity }: CreateCustomRoleInput) => {
    const input = CustomRoleTranslator.toRequest(formEntity)
    await createCompanyRoleMutation({ variables: { params: input } })
  }

  const updateCustomRole = async ({ roleId, formEntity }: UpdateCustomRoleInput) => {
    const input = CustomRoleTranslator.toRequest(formEntity)
    await updateCompanyRoleMutation({ variables: { roleId, params: input } })
  }

  const deleteCustomRole = async ({ roleId }: DeleteCustomRoleInput) => {
    await deleteCompanyRoleMutation({ variables: { input: roleId } })
  }

  return {
    createCustomRole,
    updateCustomRole,
    deleteCustomRole,
  }
}
